import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'
import { ORG_REGISTRATIONS_PER_PAGE } from '../../features/organization/registration/constants'
import { toOrgRegistrations } from '../../features/organization/registration/utils/mappers'
import type {
  OrgRegistration,
  OrgRegistrationFilters,
  OrgRegistrationsResponseApi,
} from '../../features/organization/registration/types'
import { toPagePagination, type Page } from '../../ts-utils/pagedList'

interface GetOrgRegistrationsArgs {
  orgId: string
  filters: OrgRegistrationFilters
  page?: number
}

/**
 * One page of an organization's registrations for one status tab — its own
 * only, or with every sub-organization's too (`recursive`).
 * `GET /organizations/:id/registrations`
 */
export const getOrgRegistrations = async ({
  orgId,
  filters,
  page = 1,
}: GetOrgRegistrationsArgs): Promise<Page<OrgRegistration>> => {
  const response: OrgRegistrationsResponseApi | undefined = await req(
    ENDPOINTS.ORGANIZATIONS.REGISTRATIONS(orgId),
    {
      method: 'GET',
      query: {
        status: filters.status,
        // Free-text search goes as `query`, like the other list endpoints
        // (org children, schedule events, admin searches).
        query: filters.search.trim() || undefined,
        sport_id: filters.sportId || undefined,
        generic_sport_id: filters.genericSportId || undefined,
        venue_id: filters.venueId || undefined,
        recursive: filters.showChildOrganizations ? 1 : 0,
        page,
        per_page: ORG_REGISTRATIONS_PER_PAGE,
      },
    }
  )

  return {
    data: toOrgRegistrations(response?.data),
    pagination: toPagePagination(response?.meta?.pagination, page),
  }
}
